module.exports = __webpack_public_path__ + "img/symphony_542_cacao.c2a7e6e4.jpg";